import type { AuthActionMode } from "./types";

const MODES: ReadonlySet<string> = new Set<AuthActionMode>([
  "resetPassword",
  "verifyEmail",
  "recoverEmail",
  "revertSecondFactorAddition",
  "signIn",
  "confirmEmailChange",
  "undoEmailChange"
]);

export const actionMode = (params: URLSearchParams): AuthActionMode | null => {
  const mode = params.get("mode") ?? "";
  return MODES.has(mode) ? (mode as AuthActionMode) : null;
};

/**
 * Where an email sign-in link continues to, with every query parameter kept
 * so `isSignInWithEmailLink` recognizes it there. Only same-origin targets;
 * anything else falls back to `fallbackPath`.
 */
export const signInContinueUrl = (
  href: string,
  fallbackPath = "/login"
): string => {
  const here = new URL(href);
  const raw = here.searchParams.get("continueUrl");
  let target: URL;
  try {
    target = new URL(raw ?? fallbackPath, here.origin);
  } catch {
    target = new URL(fallbackPath, here.origin);
  }
  if (target.origin !== here.origin)
    target = new URL(fallbackPath, here.origin);
  here.searchParams.forEach((value, key) => {
    if (key !== "continueUrl") target.searchParams.set(key, value);
  });
  return `${target.pathname}${target.search}${target.hash}`;
};

/** The `oobCode` inside a Firebase action link, such as a password-reset link. */
export const oobCodeFromLink = (link: string): string | null => {
  try {
    return new URL(link).searchParams.get("oobCode");
  } catch {
    return null;
  }
};
